import { render, staticRenderFns } from "./relatorio-despesas.vue?vue&type=template&id=b9d4cfb4&scoped=true&"
import script from "./relatorio-despesas.vue?vue&type=script&lang=js&"
export * from "./relatorio-despesas.vue?vue&type=script&lang=js&"
import style0 from "./styles/report.scss?vue&type=style&index=0&id=b9d4cfb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d4cfb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VCard,VCardText,VCardTitle,VIcon})
